import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {INLINE_USER_DASHBOARD_URLS} from "../PanelConstants.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {Flow} from "./Flow.js";


export class DashboardFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.dashboard;
    card = null; // TODO what are these? Comment or remove.
    entries = null;

    getFlowPlan() {
        return [Flow.auth];
    }

    finalize() {
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}
